var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { Text } from "../../../components/elements/Text";
import { Button } from "../../../components/elements/Button";
import IconWarningImage from "../../../../images/icone-warning.svg";
import { Container, Wrapper, ContentContainer, InfoContainer, CheckImage, TitleBox, } from "./styles";
import { EmailConfirmationToast } from "../../../components/modules/EmailConfirmationToast";
import { requestEmail } from "../../../services/confirmEmailService";
import { Card } from "../../../components/modules/Card";
import ResendLink from "../../../components/modules/ResendLink";
export function ConfirmEmailIncomplete() {
    var _a = __read(useState(false), 2), toastOpen = _a[0], setToastOpen = _a[1];
    var navigate = useNavigate();
    var loginId = useParams().loginId;
    useEffect(function () {
        if (!loginId)
            navigate("/login");
        onRequestResend();
    }, []);
    function onRequestResend() {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, requestEmail(loginId)];
                    case 1:
                        _a.sent();
                        setToastOpen(true);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        navigate("/erro/500");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return (_jsxs(Container, { children: [_jsx(Wrapper, { children: _jsx(Card, { children: _jsx(ContentContainer, { children: _jsxs(InfoContainer, { children: [_jsx(CheckImage, { src: IconWarningImage, alt: "success" }), _jsx(TitleBox, __assign({ as: Text, renderAs: "h2", textStyle: "body1", color: "fakeBlack" }, { children: _jsx(Text, __assign({ textStyle: "subtitle1", color: "fakeBlack" }, { children: "Voc\u00EA ainda n\u00E3o confirmou seu e-mail." })) })), _jsx(Box, __assign({ marginBottom: "3rem" }, { children: _jsx(Text, __assign({ textStyle: "body1", color: "fakeBlack" }, { children: "Acesse o link que enviamos e fa\u00E7a a confirma\u00E7\u00E3o." })) })), _jsx(ResendLink, { href: "#resend", onClick: function (evt) {
                                        onRequestResend();
                                        evt.preventDefault();
                                    } }), _jsx(Button, { children: "VOLTAR", colorScheme: "gradient", buttonVariant: "h2", onClick: function () { return navigate("/login"); } })] }) }) }) }), _jsx(EmailConfirmationToast, { isOpen: toastOpen, onDismiss: function () { return setToastOpen(false); } })] }));
}
